<template>
  <div class="page-review-requirement">
    <div class="banner-con">
      <img src="/img/bg-product_small.jpg" alt="" />
      <div class="desc-con">
        {{
          $t(
            "Looking to have your very own drone or itching to acquire a new one? Click the button below to get in touch with us, and prepare to be pleasantly surprised by our fantastic prices!"
          )
        }}
      </div>
      <a target="_blank" href="mailto:sales@aimrobotics.io">
        <md-button class="md-simple contect-btn">
          {{ $t("CONTACT US") }}
        </md-button>
      </a>
    </div>
    <div class="requirements-title">
      {{ $t("Flight Review Reqiurements") }}
    </div>
    <div class="requirements">
      <div class="block" :class="pilotQuantity > 0 ? 'active' : ''">
        <img src="/img/check_file.png" alt="" />
        <div class="title">Pilot</div>
        <div v-if="pilotQuantity > 0">
          {{ $t("Pilot information retrieved.") }}
        </div>
        <div v-else>
          <div class="desc">
            {{
              $t(
                "To proceed with the Flight Review, please click the button below to enter the Pilot information."
              )
            }}
          </div>
          <md-button
            class="md-primary  md-simple border"
            @click="navigation('/settings/pilot')"
          >
            {{ $t("Add pilot") }}
          </md-button>
        </div>
      </div>
      <div class="block" :class="droneQuantity > 0 ? 'active' : ''">
        <img src="/img/drone.png" alt="" />
        <div class="title">RPAS</div>
        <div v-if="droneQuantity > 0">
          {{ $t("RPAS information retrieved.") }}
        </div>
        <div v-else>
          <div class="desc">
            {{
              $t(
                "To proceed with the Flight Review, please click the button below to enter the drone information."
              )
            }}
          </div>
          <md-button
            class="md-primary md-simple border"
            @click="navigation('/settings/drone')"
          >
            {{ $t("Add RPAS") }}
          </md-button>
        </div>
      </div>
      <div>
        <md-button
          class="md-primary border booking-btn"
          :disabled="pilotQuantity > 0 && droneQuantity > 0 ? false : true"
          @click="navigation('/flight-review/booking')"
        >
          {{ $t("Book Flight Review Now") }}
          <span class="material-icons">touch_app</span>
        </md-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  name: "requirement",
  data() {
    return {};
  },
  computed: {
    ...mapFields("setting", ["pilotQuantity", "droneQuantity"])
  },
  mounted() {
    this.$store.dispatch("setting/getSettings");
  },
  methods: {
    navigation(url) {
      this.$router.push(url);
    }
  }
};
</script>
<style lang="scss">
.page-review-requirement {
  .border {
    outline: auto;
  }
  .banner-con {
    width: 100%;
    height: 300px;
    position: relative;
    img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
      top: 0;
      left: 0;
      z-index: 0;
    }
    .desc-con {
      z-index: 1;
      position: relative;
      width: 40%;
      color: #fff;
      padding-top: 50px;
      margin-left: 24px;
      font-size: 20px;
      line-height: 32px;
    }
    .contect-btn {
      position: relative;
      font-size: 18px;
      outline: auto;
      margin-top: 20px;
      margin-left: 24px;
      .md-button-content {
        color: #fff;
      }
    }
    @media (max-width: 768px) {
      .desc-con {
        width: 90%;
      }
    }
  }
  .requirements-title {
    text-align: center;
    padding: 60px 24px 24px 24px;
    font-size: 30px;
    font-weight: 600;
  }

  .requirements {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .block {
    width: 300px;
    height: 360px;
    box-sizing: border-box;
    text-align: center;
    padding: 24px;
    margin: 12px;
    border: 1px solid #ccc;
    img {
      height: 80px;
    }
    .title {
      margin: 20px 12px;
    }
    .desc {
      text-align: left;
      border-radius: 2px;
      margin-bottom: 10px;
    }
    &.active {
      border-color: #0abab5;
    }
  }
  .booking-btn {
    margin-left: 12px;
  }
}
</style>
